// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessGridAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var withHandlers = require('recompose').withHandlers;
  var CONSTANT = require('logic/data/Izenda.AccessConstants');
  const { curry, isNil, isEmpty, forEach } = require('lodash/fp');

  var AccessGridAction = withHandlers({
    onClickDelete: curry(onClickDelete),
    onClickAdd: curry(onClickAdd),
    checkAll: curry(checkAll),
    deleteAccess: curry(deleteAccess),
    changeShareWith: curry(changeShareWith),
    changeAccessRight: curry(changeAccessRight),
    onChangeSelectCell: curry(onChangeSelectCell),
    onSortChange: curry(onSortChange),
    updateSearchCriteria: curry(updateSearchCriteria),
    onPageSizeChange: curry(onPageSizeChange),
    search: curry(search),
    checkDirty: checkDirty
  });

  /**
   * Deleted all access
   * @param  {object} props
   * @param  {object} event
   */
  function onClickDelete(props, event) {
    var store = props.store;
    var model = store.model;
    props.validation.reset();
    var message = props.accessMode === CONSTANT.ACCESS_MODE.TENANT ? CONSTANT.MESSAGE.M02b : CONSTANT.MESSAGE.M01b;
    props.confirmFn('Confirmation', { description: message }).then(function() {
      model.deleteAccess();
    });
  }

  /**
   * Add new access
   * @param  {object} props
   * @param  {object} event
   */
  function onClickAdd(props, event) {
    props.validation.reset();
    var store = props.store;
    var model = store.model;
    model.addAccess();
  }

  /**
   * Check all access
   * @param  {object} props
   * @param  {object} value
   * @param  {object} event
   */
  function checkAll(props, value, event) {
    var store = props.store;
    var model = store.model;
    forEach(function(item) {
      item.updateSelected(value);
    }, model.accessList);
  }

  /**
   * Delete single access
   * @param  {object} props
   * @param  {object} item
   * @param  {object} event
   */
  function deleteAccess(props, item, event) {
    var store = props.store;
    var model = store.model;
    props.validation.reset();
    var message = props.accessMode === CONSTANT.ACCESS_MODE.TENANT ? CONSTANT.MESSAGE.M02a : CONSTANT.MESSAGE.M01a;
    props.confirmFn('Confirmation', { description: message }).then(function() {
      item.delete();
      model.pageInfo.descreaseRecord();
    });
  }

  /**
   * Change share type access
   * @param  {object} props
   * @param  {object} item
   * @param  {object} value
   * @param  {object} event
   */
  function changeShareWith(props, item, value, event) {
    if (!isNil(value) && !isEmpty(value)) {
      value = parseInt(value);
    }
    item.updateAssignedType(value, 'assignedType');
  }

  /**
   * Change access right access
   * @param  {object} props
   * @param  {object} item
   * @param  {object} value
   * @param  {object} event
   */
  function changeAccessRight(props, item, key, value, event) {
    item.updateAccessRight(value, key);
  }

  /**
   * Change slected access
   * @param  {object} props
   * @param  {object} item
   * @param  {object} value
   * @param  {object} event
   */
  function onChangeSelectCell(props, item, value, event) {
    item.updateSelected(value);
  }

  /**
   * Handle on sort change, if access mode # report ignore dirty form warmning
   * @param  {object} props   react compponet props
   * @param  {object} value   new sort value
   */
  function onSortChange(props, columnKey, sortDir) {
    var store = props.store;
    var model = store.model;
    props.validation.reset();
    if (props.accessMode !== CONSTANT.ACCESS_MODE.REPORT) {
      return props.confirmDirtyForm(model.checkDirty()).then(store.onSortChange.bind(store, columnKey, sortDir));
    } else {
      return store.onSortChange(columnKey, sortDir);
    }
  }

  /**
   * Search access.
   * @param  {object} props          component props
   * @param  {object} searchProperty search criteria
   * @param  {string} searchText     search value
   * @return {object}                promise result
   */
  function search(props, searchProperty, searchText) {
    var store = props.store;
    var model = store.model;
    props.validation.reset();
    if (props.accessMode !== CONSTANT.ACCESS_MODE.REPORT) {
      return props
        .confirmDirtyForm(model.checkDirty())
        .then(store.search.bind(store, searchProperty, searchText, props.accessMode));
    } else {
      return store.search.bind(store, searchProperty, searchText)();
    }
  }

  /**
   * Search access.
   * @param  {object} props          component props
   * @param  {object} searchProperty search criteria
   * @param  {string} searchText     search value
   * @return {object}                promise result
   */
  function updateSearchCriteria(props, searchProperty, searchText) {
    props.validation.reset();
    props.store.updateSearchCriteria(searchProperty, searchText);
  }

  /**
   * Check dirty for change paging, update sort, will ignore in report access
   * @param  {object} props component props
   * @return {boolean}      result
   */
  function checkDirty(props) {
    return function() {
      var store = props.store;
      var model = store.model;

      if (props.accessMode !== CONSTANT.ACCESS_MODE.REPORT) {
        return model.checkDirty();
      } else {
        return false;
      }
    };
  }

  /**
   * Search access.
   * @param  {object} props      component props
   * @param  {object} pageSize   page size
   * @return {object}            promise result
   */
  function onPageSizeChange(props, pageSize, event) {
    props.validation.reset();
    return props.store.onPageSizeChange(pageSize);
  }

  module.exports = AccessGridAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Access/Izenda.AccessGridAction.js